import AppHeader from 'components/app-header';
import { Style, Button, Toast, Dialog, Input } from 'cube-ui';
import apis from 'api/index';

export const commonMixin = {
  components: {
    AppHeader,
    Button,
    cubeInput: Input,
  },
  methods: {
    showToast(text, type='error') {
      const toast = this.$createToast({
        txt: text,
        type,
        time: 2000
      });
      toast.show();
    },
    showDialog(text, type = 'alert', confirmFn) {
      this.$createDialog({
       type,
       icon: 'cubeic-alert',
       showClose: false,
       title: text,
       onConfirm: confirmFn
     }).show()
   },
    // 获取模块列表
    async fetchModuleList() {
      try {
        const res = await apis.getModuleList();
        return res;
      } catch(err) {
        console.error(err);
      }
    },
    // 格式化模块列表
    _normalizeModule(data) {
      return data.map(item => {
        return {
          id: item.id,
          text: item.name,
          remark: item.remark,
          value: item.id,
          status: item.status,
        }
      })
    },
  }
}